import React from 'react'

type IconProps = {
  className?: string
  size?: number
}

/** Panel-left outline — closed admin menu (open left sidebar). */
export const PanelLeftIcon: React.FC<IconProps> = ({ className, size = 22 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M9 3v18" />
  </svg>
)

/**
 * Panel-left filled — open admin menu (collapse left sidebar).
 * Left pane solid, right pane hollow outline.
 */
export const PanelLeftFilledIcon: React.FC<IconProps> = ({ className, size = 22 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm6 1.5h8c.276 0 .5.224.5.5v14a.5.5 0 0 1-.5.5h-8V4.5Z"
    />
  </svg>
)
